export default function ({ redirect, route }) {
    redirect({ path: '/shop', query: route.query });
}
